// Utilitarios globais do layout (dependem de jQuery via $j)

function formatarValor(valor) {
  valor = valor.replace(/[\D]+/g, '')
  if (!valor) return '0,00'

  valor = valor.padStart(3, '0')
  var decimal = valor.slice(-2)
  var inteiro = valor.slice(0, -2).replace(/^0+/, '') || '0'
  inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return inteiro + ',' + decimal
}

function exibe_spinner() {
  limpa_mensagem()
  $j('.spinner-overlay').css('display', 'flex')
}

function oculta_spinner() {
  $j('.spinner-overlay').css('display', 'none')
}

function limpa_mensagem() {
  $j('#fundo-da-mensagem').removeClass('bg-green-200')
  $j('#texto-da-mensagem').removeClass('text-green-800')
  $j('#fundo-da-mensagem').removeClass('bg-red-200')
  $j('#texto-da-mensagem').removeClass('text-red-800')
  $j('#texto-da-mensagem').text('')
  $j('#mensagem').hide()
}

function converteHoraParaDecimal(horaStr) {
  const partes = horaStr.split(':')
  const horas = parseInt(partes[0], 10) || 0
  const minutos = parseInt(partes[1], 10) || 0
  return horas + minutos / 60
}

// Expor globalmente (usado em diversas views)
window.exibe_spinner = exibe_spinner
window.oculta_spinner = oculta_spinner
window.limpa_mensagem = limpa_mensagem
window.converteHoraParaDecimal = converteHoraParaDecimal

// Bind do formata_valor quando DOM pronto
$j(document).ready(function() {
  $j('.formata_valor').on('input', function() {
    let valor = $j(this).val()
    $j(this).val(formatarValor(valor))
  })
})
